/* istanbul ignore file */
import { Icon, InputProps, InputType } from '@distribusion/owl-frontend-ui'
import { FieldProps } from 'formik'
import React, { ReactElement, useState } from 'react'

import InputField from '@ui/Input/Field'

type PasswordFieldProps = FieldProps &
  InputProps & {
    updateEvent?: 'onChange' | 'onBlur'
  }

const PasswordField = (props: PasswordFieldProps): ReactElement => {
  const [showPassword, setShowPassword] = useState(false)

  const toggleInputType = (isVisible: boolean): InputType => (isVisible ? 'text' : 'password')

  const passwordProps = {
    ...props,
    type: toggleInputType(showPassword),
    autoComplete: 'new-password', // this prevents autofill on iOS interfering with password masking
    iconAfter: (
      <div className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
        <Icon name={showPassword ? 'eye-closed' : 'eye-open'} size="large" />
      </div>
    ),
  }

  return <InputField {...passwordProps} />
}

export default PasswordField
